module.exports = __webpack_public_path__ + "static/media/a.f855014b.jpg";